<template>
  <footer id="footer" class="footer">
    <a href="#" class="go-top"> 
      <img src="https://static.igem.wiki/teams/4185/wiki/arrow-footer.jpeg"/>
    </a>
    <div class="sponsors-bottom">

<br><br>
<span><a href="https://she.mumc.maastrichtuniversity.nl/" target="_blank"><img style="width: 50%;" src="https://static.igem.wiki/teams/4185/wiki/she-logo.png" alt="SHE (The School of Health Professions Education)"/></a></span>
<span><a href="https://merlninstitute.com/" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/merln-um-element-donkerblauw-met-tekst-wijder.png" alt="MERLN institute"/></a></span>
<span><a href="https://www.snapgene.com/" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/logo-snapgene-dotmatics.svg" alt="Snapgene (Gene Editing Software Company)"/></a></span>
<span><a href="https://eu.idtdna.com/pages" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/idt-logo.png" alt="IDT labs (an ICT Company)"/></a></span>
<span><a href="https://nld.promega.com/" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/promega-logo.jpg" alt="Promega"/></a></span>
<span><a href="https://www.ufl-swol.nl/" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/logo-swol.png" alt="Swol"/></a></span>
<span><a href="https://nijsen.co/en/" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/logo-nijsen-company.svg" alt="Nijsen"/></a></span>
<span><a href="https://www.maastrichtuniversity.nl/" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/university-logo.png" alt="Maastricht University"/></a></span>
<span><a href="https://www.carimmaastricht.nl/" target="_blank"><img src="https://static.igem.wiki/teams/4185/wiki/carim-logo-1.png" alt="Carim"/></a></span>

</div>
    <div class="footer-top">
      <div class="sections">
        <div class="section">
       <h3 class="subtitle">Bronze</h3>
          <ul class="links">
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/description">Description</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/team">Team</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/attributions">Attributions</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/contribution">Contributions</a></li>
          </ul>
          </div>
        <div class="section">
          <h3 class="subtitle">Silver</h3>
          <ul class="links">
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/engineering">Engineering</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/collaborations">Collaboration</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/implementation">Implementation</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/human-practices">Human Practices</a></li>
          </ul>
        </div>
        <div class="section">
          <h3 class="subtitle">Gold</h3>
          <ul class="links">
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/communication">Education</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/model">Modelling</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/proof-of-concept">Concept</a></li>
            <li><a class="link" href="https://2022.igem.wiki/msp-maastricht/human-practices">Human Practices</a></li>
          </ul>
              
              <li class="social">
                <a class="socialLink" href="">
                  <i class="fa-brands fa-instagram"></i>
                </a>
                <a class="socialLink" href="">
                  <i class="fa-brands fa-facebook-f"></i>
                </a>
                <a class="socialLink" href="">
                  <i class=bx 
                  :class="bxl-twitter" />
                </a>
                <a class="socialLink" href="">
                  <i class="fa-brands fa-linkedin-in"></i>
                </a>
              </li>
            
          </div>
        </div>
      </div>
    

    <div class="footer-bottom">
      <p class="credits">
        Gitlab Repository link
        <a target="blank" href="https://gitlab.igem.org/2022/msp-maastricht"
          >MSP-MAASTRICHT</a
        >
      </p>
      <p class="credits">
        © 2022 MSP-Maastricht iGem. | Licensed under
        <a target="blank" href="https://creativecommons.org/licenses/by/4.0/"
          >(CC BY 4.0)</a
        >
      </p>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  color: #01262F;

  height: 100vh;
  display: flex;
  justify-content: space-evenly;
}
.go-top {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.4s;
  cursor: pointer;
  text-decoration: none;
  width: 5%;

}
.go-top:hover {
  background-color: #79BCD6;
}
.go-top > h3 {
  margin: 0;
  padding: 0.5rem;
  color: white;
}
.footer-top {
  display: flex;
  justify-content: center;
  background-color: black;
  color: white;
  padding-top: 1rem;
  width: 100%;

}
.footer-bottom {
  background-color: black;
  color: white;
  width: 100%;

}
.sponsors-bottom {
  width: 75%;
  overflow: hidden;
  align-content: center;



}
.sponsors-bottom img {
    width: 15%;
    object-fit: contain;
    overflow: hidden;
    padding: 1rem;
}


.sections {
  display: flex;
  gap: 5rem;
}

.section {
  display: flex;
  flex-direction: column;
}

.subtitle {
  font-size: 1rem;
}
.links {
  list-style: none;
  padding: 0;
  margin: 0;
}
.link,

.link:hover {
  color: grey;
  text-decoration: underline;
  transition: 0.4s;
}
.social {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.socialLink {
  text-decoration: none;
  font-size: 0.9rem;
  transition: 0.4s;
  color: white;
}
.socialLink:hover {
  color: var(--grey);
}
.divider {
  width: 90%;
}
.credits {
  font-size: 1rem;
  font-weight: 300;
  text-align: center;
  
}
@media screen and (max-width: 900px) {
  .sections {
    gap: 1rem;
  }
  .section {
    text-align: center;
    align-items: center;
  }
  .footer-top {
    padding: 0 1rem;
  }
  .subtitle {
    font-size: 1rem;
  }
  .sections {
    justify-content: center;
  }
}
</style>